import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, withCtx as _withCtx } from "vue";
const _hoisted_1 = {
    key: 1,
    class: "df-amount__error",
    role: "alert"
};
import { computed } from "vue";
import { useDonation } from "../context/donationContext";
import { useChrome } from "../i18n/useChrome";
import { useFieldErrors } from "../composables/useFieldErrors";
import StepShell from "../components/layout/StepShell.vue";
import FrequencySelector from "../components/amount/FrequencySelector.vue";
import PresetAmountGrid from "../components/amount/PresetAmountGrid.vue";
import CustomAmountInput from "../components/amount/CustomAmountInput.vue";
import ImpactStatement from "../components/amount/ImpactStatement.vue";
import TaxReductionStatement from "../components/amount/TaxReductionStatement.vue";
import BaseButton from "../components/ui/BaseButton.vue";
export default /*@__PURE__*/ _defineComponent({
    __name: 'StepAmount',
    setup(__props) {
        // SYNC: see ../_SYNC.md.
        const ctx = useDonation();
        const { amountMinor, formatMinor, allowCustom, minimumAmountMinor, frequency, frequencySuffixToken, canProceed, next, } = ctx;
        const { tf } = useChrome();
        const { touchAll, errorFor } = useFieldErrors(ctx);
        const suffix = computed(() => frequencySuffixToken.value ? ` ${tf(`frequency.suffix.${frequency.value}`)}` : "");
        const continueLabel = computed(() => `${tf("actions.continue")} · ${formatMinor(amountMinor.value)}${suffix.value}`);
        const amountError = computed(() => {
            const leaf = errorFor("amount");
            return leaf ? tf(`field.${leaf}`, { min: formatMinor(minimumAmountMinor.value ?? 0) }) : "";
        });
        function onContinue() {
            touchAll();
            next();
        }
        return (_ctx, _cache) => {
            return (_openBlock(), _createBlock(StepShell, {
                title: _unref(tf)('amount.title'),
                subtitle: _unref(tf)('amount.subtitle')
            }, {
                actions: _withCtx(() => [
                    _createVNode(BaseButton, {
                        variant: "primary",
                        block: "",
                        "aria-disabled": !_unref(canProceed),
                        onClick: _cache[0] || (_cache[0] = ($event) => (onContinue()))
                    }, {
                        default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(continueLabel.value), 1 /* TEXT */)
                        ]),
                        _: 1 /* STABLE */
                    }, 8 /* PROPS */, ["aria-disabled"])
                ]),
                default: _withCtx(() => [
                    _createVNode(FrequencySelector, { class: "df-amount__freq" }),
                    _createVNode(PresetAmountGrid, { class: "df-amount__presets" }),
                    (_unref(allowCustom))
                        ? (_openBlock(), _createBlock(CustomAmountInput, {
                            key: 0,
                            class: "df-amount__custom",
                            error: amountError.value
                        }, null, 8 /* PROPS */, ["error"]))
                        : (amountError.value)
                            ? (_openBlock(), _createElementBlock("p", _hoisted_1, _toDisplayString(amountError.value), 1 /* TEXT */))
                            : _createCommentVNode("v-if", true),
                    _createVNode(ImpactStatement),
                    _createVNode(TaxReductionStatement, { class: "df-amount__tax" })
                ]),
                _: 1 /* STABLE */
            }, 8 /* PROPS */, ["title", "subtitle"]));
        };
    }
});
